/** Call a function when enter is pressed in an input field (not in a form) */
angular.module('qkr').directive('ngEnter', () => function(scope, element, attrs) {
        element.bind('keydown keypress', (event) => {
            if (event.which === 13) {
                scope.$apply(() => {
                    scope.$eval(attrs.ngEnter, {event});
                });

                event.preventDefault();
            }
        });
    });



// WEBPACK FOOTER //
// ./src/directives/enter_input.js